import PageWrapper from "../../../components/Page/PageWrapper";
import PageTitle from "../../../components/Page/PageTitle";
import ForMonitoringHeader from "./components/ForMonitoringHeader";
import ForMonitoringTable from "./components/ForMonitoringTable";
import { useTranslation } from "react-i18next";

const ForMonitoring = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.forMonitoringReports")} />
      <ForMonitoringHeader />
      <ForMonitoringTable />
    </PageWrapper>
  );
};

export default ForMonitoring;
